export { default } from './SWProductDescriptionAndBuy';
